var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("span", [_vm._v("勋章配置")]),
          ]),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.configLoading,
                  expression: "configLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.configList, size: "mini", border: "" },
            },
            [
              _c("el-table-column", {
                key: "cfg-id",
                attrs: { prop: "id", label: "ID", width: "60" },
              }),
              _c("el-table-column", {
                key: "cfg-type",
                attrs: { label: "勋章类型", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.medalType === 1
                          ? _c("span", [_vm._v("等级勋章")])
                          : scope.row.medalType === 2
                          ? _c("span", [_vm._v("拼团大使")])
                          : scope.row.medalType === 3
                          ? _c("span", [_vm._v("王者荣誉")])
                          : scope.row.medalType === 4
                          ? _c("span", [_vm._v("V5荣誉")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                key: "cfg-name",
                attrs: { prop: "medalName", label: "勋章名称", width: "120" },
              }),
              _c("el-table-column", {
                key: "cfg-icon",
                attrs: { prop: "medalIcon", label: "图标", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.medalIcon
                          ? _c("el-image", {
                              staticStyle: { width: "30px", height: "30px" },
                              attrs: {
                                src: scope.row.medalIcon,
                                fit: "contain",
                              },
                            })
                          : _c("span", [_vm._v("-")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                key: "cfg-desc",
                attrs: {
                  prop: "medalDesc",
                  label: "获取条件",
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                key: "cfg-op",
                attrs: { label: "操作", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["admin:kx:medal:update"],
                                expression: "['admin:kx:medal:update']",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEditConfig(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "编辑勋章配置",
            visible: _vm.editDialogVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.editForm,
                "label-width": "100px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "勋章名称" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.editForm.medalName,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "medalName", $$v)
                      },
                      expression: "editForm.medalName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "图标URL" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "图标URL" },
                    model: {
                      value: _vm.editForm.medalIcon,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "medalIcon", $$v)
                      },
                      expression: "editForm.medalIcon",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "获取条件" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 2 },
                    model: {
                      value: _vm.editForm.medalDesc,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "medalDesc", $$v)
                      },
                      expression: "editForm.medalDesc",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.editDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.handleSaveConfig },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "box-card mt14" },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("span", [_vm._v("用户勋章管理")]),
          ]),
          _c(
            "el-form",
            { staticClass: "mb14", attrs: { inline: "", size: "small" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "用户查询：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "260px" },
                    attrs: { placeholder: "请输入UID或手机号", clearable: "" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleSearchMedal($event)
                      },
                    },
                    model: {
                      value: _vm.keyword,
                      callback: function ($$v) {
                        _vm.keyword = $$v
                      },
                      expression: "keyword",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSearchMedal },
                    },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { on: { click: _vm.resetSearch } }, [
                    _vm._v("重置"),
                  ]),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["admin:kx:medal:grant"],
                          expression: "['admin:kx:medal:grant']",
                        },
                      ],
                      attrs: { type: "success" },
                      on: {
                        click: function ($event) {
                          _vm.grantDialogVisible = true
                        },
                      },
                    },
                    [_vm._v("手动授予")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.userLoading,
                  expression: "userLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.userMedals,
                size: "mini",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "60" },
              }),
              _c("el-table-column", {
                key: "usr-uid",
                attrs: { prop: "uid", label: "用户UID", width: "100" },
              }),
              _c("el-table-column", {
                key: "usr-nickname",
                attrs: {
                  prop: "nickname",
                  label: "昵称",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                key: "usr-phone",
                attrs: {
                  prop: "phone",
                  label: "手机号",
                  width: "130",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                key: "usr-type",
                attrs: { label: "勋章类型", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.medalType === 1
                          ? _c("span", [_vm._v("等级勋章")])
                          : scope.row.medalType === 2
                          ? _c("span", [_vm._v("拼团大使")])
                          : scope.row.medalType === 3
                          ? _c("span", [_vm._v("王者荣誉")])
                          : scope.row.medalType === 4
                          ? _c("span", [_vm._v("V5荣誉")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                key: "usr-name",
                attrs: { prop: "medalName", label: "勋章名称", width: "120" },
              }),
              _c("el-table-column", {
                key: "usr-time",
                attrs: {
                  prop: "obtainTime",
                  label: "授予时间",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                key: "usr-op",
                attrs: { label: "操作", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-popconfirm",
                          {
                            attrs: { title: "确定撤销该勋章？" },
                            on: {
                              confirm: function ($event) {
                                return _vm.handleRevoke(scope.row)
                              },
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: ["admin:kx:medal:revoke"],
                                    expression: "['admin:kx:medal:revoke']",
                                  },
                                ],
                                staticStyle: { color: "#f56c6c" },
                                attrs: {
                                  slot: "reference",
                                  type: "text",
                                  size: "mini",
                                },
                                slot: "reference",
                              },
                              [_vm._v("撤销")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            staticStyle: { "margin-top": "20px", "text-align": "right" },
            attrs: {
              "current-page": _vm.page.page,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.page.limit,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "手动授予勋章",
            visible: _vm.grantDialogVisible,
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.grantDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.grantForm,
                "label-width": "80px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "用户UID" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 1 },
                    model: {
                      value: _vm.grantForm.uid,
                      callback: function ($$v) {
                        _vm.$set(_vm.grantForm, "uid", $$v)
                      },
                      expression: "grantForm.uid",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "勋章类型" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "选择勋章" },
                      model: {
                        value: _vm.grantForm.medalType,
                        callback: function ($$v) {
                          _vm.$set(_vm.grantForm, "medalType", $$v)
                        },
                        expression: "grantForm.medalType",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "等级勋章", value: 1 },
                      }),
                      _c("el-option", {
                        attrs: { label: "拼团大使", value: 2 },
                      }),
                      _c("el-option", {
                        attrs: { label: "王者荣誉", value: 3 },
                      }),
                      _c("el-option", { attrs: { label: "V5荣誉", value: 4 } }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.grantDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.handleGrant },
                },
                [_vm._v("授予")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }